export enum ActionType 
{
   THEN,
   ELSE,
   GOTO
}